// extracted by mini-css-extract-plugin
export default {"modal":"mainOrganizationModal_modal__B0TUI","classes":"mainOrganizationModal_classes__N0E78","tag":"mainOrganizationModal_tag__59ji8"};